import React from 'react'
import { LoadingModal } from 'components/layout/Modal'

export default function BusyMask({element}) {
  return (
    <LoadingModal />
  )
}
